module.exports = __webpack_public_path__ + "be0d63c323c808f02c8bd99f787cc556.svg";